import type { ObjectGraph } from '@jet/environment/dependencies';
import { ClassicalAPIURL } from './ClassicalAPIURL';
import type { ClassicalAPIResponse } from './types';
import { requestClassicalAPIResource } from '../utilities/requestClassicalAPIResource';
import { Bag } from '../dependencies/bag';

export async function requestTracksMetadata(
    trackIds: string[],
    objectGraph: ObjectGraph,
): Promise<ClassicalAPIResponse> {
    const countryCode = Bag.countryCode(objectGraph);
    const url = new ClassicalAPIURL(
        `/query/tracksMetadata/${countryCode}`,
        objectGraph,
    );

    url.queryString.addParameters({
        kind: 'song',
        ids: trackIds?.toString(),
    });

    return requestClassicalAPIResource({ url: url.string }, objectGraph);
}
